<template>
  <!-- MAIN APP -->
  <div id="diy-app">
    <div class="diy-app__wrapper">
      <!-- Menu -->
      <TheTopbar v-if="sessionStarted" />
      <!-- Sidebar -->
      <TheSidebar v-if="sessionStarted" />
      <!-- Main Content -->
      <main class="diy-app__main">
        <transition :name="sessionStarted ? 'fade' : ''" mode="out-in">
          <router-view></router-view>
        </transition>
      </main>
    </div>
    <!-- DIY app modal -->
    <DIYModal />
    <!-- app notifications -->
    <AppNotifications />
    <!-- User assets reloader -->
    <CardsAlertsReloader v-if="loggedIn" />
  </div>
</template>

<script>
// Utilities
import { authComputed } from 'Store/helpers'
// Components
import DIYModal from 'Components/DIYModal'
import TheTopbar from 'Components/TheTopbar'
import TheSidebar from 'Components/TheSidebar'
import AppNotifications from 'Components/AppNotifications'
import CardsAlertsReloader from 'Modules/CardsAlertsReloader'

export default {
  name: 'App',

  components: {
    DIYModal,
    TheTopbar,
    TheSidebar,
    AppNotifications,
    CardsAlertsReloader,
  },

  data() {
    return {
      transition: false,
    }
  },

  computed: {
    ...authComputed,

    sessionStarted() {
      return this.loggedIn && this.$route.name !== 'login'
    },

    loggedInClassName() {
      return this.loggedIn && 'logged-in'
    },
  },
}
</script>

<style src="@/assets/css/styles.css"></style>
<style>
#diy-app {
  display: flex;
  flex-direction: column;
  position: relative;
}

.diy-app__main {
  display: grid;
  justify-items: stretch;
  height: 100%;
  align-items: stretch;
  transition: var(--transition-cubic-300);
}
</style>
